import { mergeQueryString, updateSearch } from 'bernie-core';
import * as React from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { UitkSpacing } from 'uitk-react-spacing';
import { ExternalButtonTracked, TertiaryButtonTracked } from '../../utils/click-trackers';
import { PopupMessage } from './popup-message';
export var MessageAnchor = function (props) {
  var className = props.className,
    dialogId = props.dialogId,
    text = props.text,
    id = props.id,
    icon = props.icon,
    anchorClasses = props.anchorClasses,
    analytics = props.analytics,
    isNestedPopup = props.isNestedPopup,
    messages = props.messages,
    disclaimer = props.disclaimer,
    dismissAction = props.dismissAction,
    triggerAnalytics = props.triggerAnalytics,
    _a = props.buttonType,
    buttonType = _a === void 0 ? 'Tertiary' : _a,
    buttonSize = props.buttonSize,
    buttonClasses = props.buttonClasses;
  var location = useLocation();
  var history = useHistory();
  var linkRef = React.useRef();
  if (!location) {
    return null;
  }
  var onClick = function () {
    if (location) {
      updateSearch({
        history: history,
        location: location,
        newParams: isNestedPopup ? {
          pwaDialogNested: dialogId
        } : {
          pwaDialog: dialogId
        }
      });
    }
  };
  var trackEvent = function () {
    if ((triggerAnalytics === null || triggerAnalytics === void 0 ? void 0 : triggerAnalytics.referrerId) && analytics) {
      analytics.trackEvent(triggerAnalytics.referrerId, triggerAnalytics.linkName, analytics.omnitureData, null, true);
    }
  };
  var children = React.createElement("span", {
    "data-testid": dialogId,
    className: "".concat(anchorClasses)
  }, text && React.createElement("span", null, text), icon && React.createElement(UitkSpacing, {
    padding: {
      inlinestart: 'half',
      blockend: 'half'
    }
  }, React.createElement(UitkIcon, {
    id: id || 'message-anchor',
    name: icon.id,
    size: UitkIconSize.EXTRA_SMALL,
    "aria-label": icon.description,
    title: icon.description
  })));
  return React.createElement(React.Fragment, null, React.createElement(UitkLayoutPosition, {
    className: className,
    type: "relative",
    position: {
      top: 'zero',
      zindex: 'layer2'
    }
  }, buttonType === 'Link' && React.createElement(Link, {
    to: {
      pathname: location.pathname,
      search: mergeQueryString(location.search, {
        pwaDialogNested: dialogId
      })
    },
    innerRef: linkRef,
    onClick: trackEvent,
    role: "button"
  }, children), buttonType === 'Tertiary' && React.createElement(UitkSpacing, {
    padding: {
      block: 'unset'
    }
  }, React.createElement(TertiaryButtonTracked, {
    key: "message-router",
    rfrr: (triggerAnalytics === null || triggerAnalytics === void 0 ? void 0 : triggerAnalytics.referrerId) || '',
    linkName: (triggerAnalytics === null || triggerAnalytics === void 0 ? void 0 : triggerAnalytics.linkName) || '',
    domRef: linkRef,
    onClick: onClick,
    className: "".concat(buttonClasses),
    size: buttonSize
  }, children)), buttonType === 'Anchor' && React.createElement(UitkSpacing, {
    padding: {
      block: 'unset'
    }
  }, React.createElement(ExternalButtonTracked, {
    key: "message-router",
    rfrr: (triggerAnalytics === null || triggerAnalytics === void 0 ? void 0 : triggerAnalytics.referrerId) || '',
    linkName: (triggerAnalytics === null || triggerAnalytics === void 0 ? void 0 : triggerAnalytics.linkName) || '',
    onClick: onClick,
    domRef: linkRef,
    role: "button",
    className: "uitk-link review-button-small",
    size: buttonSize
  }, children))), React.createElement(PopupMessage, {
    key: "popup-message",
    dialogId: dialogId,
    analytics: analytics,
    isNestedPopup: isNestedPopup,
    messages: messages,
    dismissAction: dismissAction,
    disclaimer: disclaimer,
    linkRef: linkRef
  }));
};